import { Component } from 'react';
import {
    Box, Button,
} from '@mui/material';

const Constants = require("../constants/Constants");
let IMAGE_URL = Constants.IMAGE_URL


class HomeNavButton extends Component {

    constructor(props) {
        super(props);        
        this.state = {
            value: ""
        }
        this.id = props.id
        this.handleClick = this.handleClick.bind(this)

    }

    handleClick() {
        const { targetPage } = this.props

        this.props.navigate(targetPage)
    }

    render() {

        return (
            <Box
                display="flex"
                justifyContent="center"
                alignitems="center"
            >
                <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    display="flex"
                    justifyContent="center"
                    alignitems="center"
                    sx={{ p: 2, border: 2, borderRadius: 3, borderColor: "Black", bgcolor: "primary.main"}}
                    style={{ width: "200px", height: "70px" }}
                    onClick={this.handleClick}
                >
                    <img
                        loading="lazy"
                        src={`${IMAGE_URL}${this.props.imgPath}`}
                        // style={{ width: this.props.imgWidth }}
                        
                        style={{ height: '60%' }}
                        alt={this.props.atlName}
                    />
                </Button>
            </Box>
        )

    }
}

export default HomeNavButton
